import { useRef, useEffect } from 'react'
import { MagnifyingGlassIcon, XMarkIcon, SpinnerIcon } from '../../../components/ui/icons'

interface AddressInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
  loading?: boolean
  onClear?: () => void
}

export function AddressInput({
  value,
  onChange,
  placeholder = 'Search for address...',
  autoFocus = false,
  loading = false,
  onClear,
}: AddressInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus()
    }
  }, [autoFocus])

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        {loading ? (
          <SpinnerIcon className="size-5 text-text-tertiary" />
        ) : (
          <MagnifyingGlassIcon className="size-5 text-text-tertiary" />
        )}
      </div>

      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          w-full py-3.5 pl-12 pr-12
          bg-surface-elevated
          border border-border-light
          rounded-xl
          text-text-primary
          placeholder:text-text-tertiary
          shadow-card
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent
          hover:border-border-default
        "
      />

      {value && onClear && (
        <button
          onClick={onClear}
          aria-label="Clear search"
          className="
            absolute inset-y-0 right-0 pr-4 flex items-center
            text-text-tertiary
            hover:text-text-secondary
            transition-colors
          "
        >
          <XMarkIcon className="size-5" />
        </button>
      )}
    </div>
  )
}
